import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ChatMessage } from './chat-message';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatApiService {

  constructor(
    private http: HttpClient,
    private userStateService: UserStateService
  ) {}

  send(message: string, history: ChatMessage[], payload: any): Observable<any> {
    const baseUrl: string = environment.AI_SERVICE_URL;
    const apiKey: string = environment.AI_SERVICE_API_KEY;

    const url = `${baseUrl}/api/chat`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${apiKey}`,
      'Content-Type': 'application/json',
    });

    const cleanHistory = history
      .filter(msg => msg.role !== 'error')
      .map(msg => ({
        role: msg.role,
        content: msg.content
      }));

    const body = {
      message,
      history: cleanHistory,
      token: this.userStateService.getAccessToken().access_token,
      payload: payload || {}
    };

    return this.http
      .post<{ response: any }>(url, body, { headers })
  }
}
